import { Helmet } from "react-helmet-async";
import { SITE } from "../data/site";

// Canonical policy: apex domain (no www), no query string or fragment,
// trailing slash on the homepage only, never on inner pages.
export const canonicalFor = (raw) => {
  const path = new URL(raw, SITE.domain).pathname.replace(/\/+$/, "");
  return `${SITE.domain}${path === "" ? "/" : path}`;
};

export default function Seo({ title, description, canonical, keywords, jsonLd, noindex }) {
  const canon = canonical ? canonicalFor(canonical) : null;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canon && <link rel="canonical" href={canon} />}
      {canon && <meta property="og:url" content={canon} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
